import React, { Component } from 'react';
import { Debounce } from 'react-throttle';
import GoogleAnalytics from 'react-ga';

import Player from '../services/player.js'

import '../../css/Playlist.css';

class Playlist extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      hidden: props.hidden
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.hidden !== this.state.hidden) {
      this.setState({
        hidden: newProps.hidden
      });
    }
  }

  
  componentDidUpdate() {

    if (Player.currentTrack) {
      let trackItem = document.querySelector(`#track_${Player.currentTrack.id}`);

      if (trackItem) {
        trackItem.scrollIntoView({ 
          behavior: 'smooth' 
        });
      }
    }

  }

  select(index) {

    GoogleAnalytics.event({
      category: 'Playlist',
      action: 'select',
      label: `${index}`
    });

    Player.loadTrack(index);
  }

  onChange(evt) {

    evt.preventDefault();

    let query = evt.target.value;

    GoogleAnalytics.event({
      category: 'Playlist',
      action: 'query',
      label: query
    });

    Player.filterPlaylist(query);

    this.setState({});
  }


  render() {

    let component = this;

    if (this.originalPlaylist && Player.originalPlaylist !== this.originalPlaylist) {
      this.refs.playlistQuery.value = '';
    } 
    
    this.originalPlaylist = Player.originalPlaylist;
    
    let playlistTracks = Player.playlist.map(function(track, index){

      let active = Player.currentTrack.id === track.id ? 'active' : '';

      return(
        <li id={`track_${track.id}`} className={`clickable ${active}`} onClick={component.select.bind(component, index)} key={track.id}>
          {index + 1}: {track.originalTitle}
        </li>
        );
    });

    return (
      <div id="playlist" style={ {display: this.state.hidden ? 'none' : 'block'} }>
      
        <h2>Playlist</h2>

        <Debounce time="200" handler="onChange">
          <input ref="playlistQuery" type="text" onChange={this.onChange.bind(this)} className="searchBar" placeholder="Search"/>        
        </Debounce>

        <ul>
          {playlistTracks}
        </ul>

      </div>
    );
  }
}

export default Playlist;



// WEBPACK FOOTER //
// ./src/js/components/Playlist.jsx